import { createPortal } from 'react-dom';
import { Icon } from '@iconify/react';

// Shared chrome for the admin attendance modals: overlay, card, header, footer.
// `actions` renders right-aligned in the footer (cancel button is built in).
const ModalShell = ({ isOpen, title, icon, onClose, children, actions, busy = false, maxWidth = "tw-max-w-md" }) => {
    if (!isOpen) return null;

    return createPortal(
        // z-index sits BELOW SearchableDropdown's portaled options panel
        // (zIndex 9999) so dropdowns inside the modal render on top of it.
        <div className="tw-fixed tw-inset-0 tw-z-[9000] tw-flex tw-items-center tw-justify-center tw-p-4 tw-bg-black/50" onClick={busy ? undefined : onClose}>
            <div
                className={`tw-bg-white tw-rounded-xl tw-shadow-2xl tw-w-full ${maxWidth} tw-max-h-[90vh] tw-flex tw-flex-col`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-border-b tw-border-gray-100">
                    <h3 className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-m-0 tw-flex tw-items-center tw-gap-1.5">
                        {icon && <Icon icon={icon} className="tw-text-base" />}
                        {title}
                    </h3>
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={busy}
                        className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-gray-400 hover:tw-bg-gray-100 hover:tw-text-gray-600 disabled:tw-opacity-50"
                        title="Close"
                    >
                        <Icon icon="mdi:close" />
                    </button>
                </div>

                <div className="tw-px-4 tw-py-4 tw-overflow-y-auto">{children}</div>

                <div className="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-px-4 tw-py-3 tw-border-t tw-border-gray-100">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={busy}
                        className="tw-px-3 tw-py-1.5 tw-rounded-md tw-border tw-border-gray-200 tw-text-gray-600 tw-text-xs tw-font-medium hover:tw-bg-gray-50 disabled:tw-opacity-50"
                    >
                        Cancel
                    </button>
                    {actions}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalShell;
